import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BookOfAccountsMenuList, NavMenus, SettingMenuList, operationMenuList } from './model/menuList';
import { Router } from '@angular/router';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss']
})
export class MenuListComponent implements OnInit {
  operationsMenuList: any = operationMenuList;
  bookOfAccountsMenuList: any = BookOfAccountsMenuList;
  settingMenuList: any = SettingMenuList;
  NavMenus: any = NavMenus;
  @ViewChild('subMenu') subMenu: any;
  @ViewChild('subMenu') actualTarget: any;
  @Output() onClose = new EventEmitter<any>();
  searchFieldDetails: any = {
    placeholder: 'Search',
    type: 'text',
    isSearchBox: true
  };
  constructor(private router: Router,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private _appService: appService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef
  ) { }

  UserId: any;
  IsKyc: any;

  ngOnInit() {
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    // console.log("NewHomeUserid", this.UserId);
    this.CheckKYC();

  }


  CheckKYC() {
    // 
    let Userid = this.UserId;
    this._appService
      .GetById("OrdersByVehicle", "checkTransporter", Userid).subscribe((response) => {
        this.IsKyc = response[0].IsKyc;
        this.updateMenuListBasedOnKYC();
        this.cdr.detectChanges();
        //console.log("Newhome KYC Flag", this.IsKyc);
      }),
      (error) => {
        console.log(error);
      }
  }

  updateMenuListBasedOnKYC() {
    if (this.IsKyc === false) {
      // Create a new menu list with 'Booking' removed
      this.NavMenus = this.NavMenus.map(nav => ({
        ...nav,
        list: nav.list.map(column => ({
          ...column,
          childMenuList: column.childMenuList.filter(item => item.label !== 'Booking')
        }))
      }));
    }
  }



  naviageToRoute(url) {
    this.router.navigateByUrl(url);
    this.onCloseClick();
  }

  onCloseClick() {
    this.onClose.emit();
  }

  onSearch(value: any) {
  }

}
